import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import TextInput, { TextInputProps } from './TextInput';

export default function PasswordInput(props: TextInputProps) {
  const [isShown, setIsShown] = useState(false);
  return (
    <TextInput
      {...props}
      onClickIcon={() => setIsShown(prev => !prev)}
      type={isShown ? 'text' : 'password'}
      icon={isShown ? <EyeSlashIcon /> : <EyeIcon />}
      color={props.errorLabelText ? 'warning' : 'primary'}
    />
  );
}
